"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODULE_ICON_KIND = void 0;
var ModuleIconKind;
(function (ModuleIconKind) {
    ModuleIconKind["PARENTING_AND_SUBSTANCE_USE"] = "PARENTING_AND_SUBSTANCE_USE";
    ModuleIconKind["POSITIVE_PARENTING"] = "POSITIVE_PARENTING";
    ModuleIconKind["PROACTIVE_PARENTING"] = "PROACTIVE_PARENTING";
    ModuleIconKind["RULES_AND_CONSEQUENCES"] = "RULES_AND_CONSEQUENCES";
    ModuleIconKind["WELLNESS_AND_CARE"] = "WELLNESS_AND_CARE";
})(ModuleIconKind || (ModuleIconKind = {}));
exports.MODULE_ICON_KIND = Object.values(ModuleIconKind);
exports.default = ModuleIconKind;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTW9kdWxlSWNvbktpbmQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZW51bXMvTW9kdWxlSWNvbktpbmQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBSyxjQU1KO0FBTkQsV0FBSyxjQUFjO0lBQ2pCLDZFQUEyRCxDQUFBO0lBQzNELDJEQUF5QyxDQUFBO0lBQ3pDLDZEQUEyQyxDQUFBO0lBQzNDLG1FQUFpRCxDQUFBO0lBQ2pELHlEQUF1QyxDQUFBO0FBQ3pDLENBQUMsRUFOSSxjQUFjLEtBQWQsY0FBYyxRQU1sQjtBQUVZLFFBQUEsZ0JBQWdCLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQyxjQUFjLENBQUMsQ0FBQztBQUU5RCxrQkFBZSxjQUFjLENBQUMifQ==